<div class="wrapper">
    <div class="header">
        <app-section-header [title]="'Accounts'" [iconName]="'accounts'" [actionsTemplate]="actionsTemplate">
            <ng-template #actionsTemplate>
                <div class="actions">
                    <button class="primary-btn" (click)="onCreateNewAccountClicked()">
                        <span class="icon" [innerHTML]="plusIcon"></span> New Account
                    </button>
                </div>
            </ng-template>
        </app-section-header>

        <section class="filters">
            <app-accounts-filters></app-accounts-filters>
        </section>
    </div>

    <section class="tabGroup">
        <lib-tab-view [(currentTab)]="currentTab" [hasSteps]="false" [alignment]="'end'">
            <lib-tab-item tabName="List" [bodyTemplate]="list" [icon]="listIcon">
                <ng-template #list>
                    <section class="tab">
                        <app-accounts-list></app-accounts-list>
                    </section>
                </ng-template>
            </lib-tab-item>

            <lib-tab-item tabName="Map" [bodyTemplate]="map" [icon]="mapIcon">
                <ng-template #map>
                    <section class="tab">
                        <app-accounts-map></app-accounts-map>
                    </section>
                </ng-template>
            </lib-tab-item>
        </lib-tab-view>
    </section>
</div>
